import { Text } from '@etiquette-ui/dynamic-table-components';
import styled from 'styled-components';

const ResponsiveText = styled(Text)`
    @media (max-width: 768px) {
        font-size: 13px;
    }
`;

export default ResponsiveText;